import clsx from "clsx";
import { SafeIcon } from "@/shared/icons";
import { Icon } from "@/shared/ui";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  onClose: () => void;
};

export default function InventorySafeHeader({ onClose }: Props) {
  return (
    <div
      className={clsx(
        "relative rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center gap-1.5",
      )}
      style={{
        background:
          "linear-gradient(90deg, rgba(54, 141, 68, 0.30) 0%, rgba(24, 24, 24, 0.00) 80%), rgba(24, 24, 24, 0.60)",
      }}
    >
      <Icon
        name="lightening"
        category="inventory"
        className="absolute bg-[#368D44] h-[4.875rem] w-[5.875rem] -left-2"
      />
      <div className="flex items-center gap-2.5">
        <SafeIcon size={24} />
        <div className="text-14 font-bold uppercase">СЕЙФ</div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
